module.exports = __webpack_public_path__ + "assets/img/parallax-bg.0bf34084.jpg";